// Core version + modules:
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// Import Swiper and modules styles
import 'swiper/css';

const container = document.querySelectorAll('.swiper.swiper-team');

if (container) {
  container.forEach((element) => {
    initSwiper(element);
  });
}

function initSwiper(container) {
  const customBreakpoints = {
    0: {
      slidesPerView: 1.25,
      spaceBetween: 16,
      navigation: {
        enabled: true,
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
        navigationDisabledClass: 'swiper-navigation-disabled'
      }
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        enabled: true,
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
        navigationDisabledClass: 'swiper-navigation-disabled'
      }
    },
    990: {
      slidesPerView: 4,
      spaceBetween: 24,
      navigation: {
        enabled: false,
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
        navigationDisabledClass: 'swiper-navigation-disabled'
      }
    }
  };

  // init Swiper:
  const swiper = new Swiper(container, {
    modules: [Navigation],
    init: false,
    breakpoints: customBreakpoints,
  });

  swiper.init();
}